import { Location } from "history";
import {
  UpdateUrlHistoryAction,
  UPDATE_INSIGHTS_URL_HISTORY,
  UPDATE_MONITORING_URL_HISTORY,
  UPDATE_ACTIONS_URL_HISTORY,
} from "./actionTypes";
import * as routes from "../../../utils/routes";

interface URLHistoryState {
  insightsHistory: Location;
  monitoringHistory: Location;
  actionsHistory: Location;
}

const INITIAL_HISTORY: Location = {
  search: "",
  pathname: "",
  hash: "",
  key: "",
  path: "",
  state: "",
};

const INITIAL_STATE: URLHistoryState = {
  insightsHistory: {
    ...INITIAL_HISTORY,
    path: routes.INSIGHTS,
    pathname: routes.INSIGHTS,
  },
  monitoringHistory: {
    ...INITIAL_HISTORY,
    path: routes.MONITORING,
    pathname: routes.MONITORING,
  },
  actionsHistory: {
    ...INITIAL_HISTORY,
    path: routes.ACTIONS,
    pathname: routes.ACTIONS,
  },
};

export function reducer(
  state = INITIAL_STATE,
  action: UpdateUrlHistoryAction
): URLHistoryState {
  switch (action.type) {
    case UPDATE_INSIGHTS_URL_HISTORY:
      return {
        ...state,
        insightsHistory: action.location,
      };
    case UPDATE_MONITORING_URL_HISTORY:
      return {
        ...state,
        monitoringHistory: action.location,
      };
    case UPDATE_ACTIONS_URL_HISTORY:
      return {
        ...state,
        actionsHistory: action.location,
      };
    default:
      return state;
  }
}
